import Vue from 'vue';
import { createDevicesConnectionModule } from '@pendo/services/MobilePairing';

export default {
    namespaced: true,
    ...createDevicesConnectionModule(Vue),
};
